import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BootstrapThemeProp, BootstrapThemeService, BootstrapThemeType } from '@app/core/services/bootstrap-theme.service';
import { IconDefinition, faXmarkLarge } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'fdx-popover-header',
    templateUrl: './popover-header.component.html',
    styleUrl: './popover-header.component.scss',
    standalone: false
})
export class PopoverHeaderComponent implements OnChanges, OnInit {

    @Input() theme: BootstrapThemeProp = 'default';
    themeType: BootstrapThemeType;
    themeClass: string;

    @Input() dismissible?: boolean = false;
    @Input() iconOverride?: IconDefinition;
    @Input() showIcon: boolean = true;
    @Output() readonly dismissed?: EventEmitter<void> = new EventEmitter<void>();

    @Input() titleText: string;
    readonly closeIcon: IconDefinition = faXmarkLarge;

    get shouldSpin(): boolean {
        return this.theme === 'downloading';
    }

    constructor(
        private bootstrapThemeService: BootstrapThemeService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if ('theme' in changes) {
            this.updateTheme(changes.theme.currentValue);
        }
    }

    ngOnInit(): void {
        this.updateTheme(this.theme);
    }

    updateTheme(newTheme: BootstrapThemeProp): void {
        this.themeType = this.bootstrapThemeService.getThemeType(newTheme);

        switch (newTheme) {
            case 'default':
            case 'downloading':
                this.themeClass = 'popover-header-default';
                break;
            default:
                this.themeClass = `popover-header-${newTheme}`;
                break;
        }
    }

    close(): void {
        this.dismissed.emit();
    }
}
